// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCourierInboxAuthTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCourierInboxAuthTokenQuery = { __typename?: 'Query', getCourierInboxAuthToken: string };


export const GetCourierInboxAuthTokenDocument = gql`
    query getCourierInboxAuthToken {
  getCourierInboxAuthToken
}
    `;

/**
 * __useGetCourierInboxAuthTokenQuery__
 *
 * To run a query within a React component, call `useGetCourierInboxAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierInboxAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierInboxAuthTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourierInboxAuthTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>(GetCourierInboxAuthTokenDocument, options);
      }
export function useGetCourierInboxAuthTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>(GetCourierInboxAuthTokenDocument, options);
        }
export type GetCourierInboxAuthTokenQueryHookResult = ReturnType<typeof useGetCourierInboxAuthTokenQuery>;
export type GetCourierInboxAuthTokenLazyQueryHookResult = ReturnType<typeof useGetCourierInboxAuthTokenLazyQuery>;
export type GetCourierInboxAuthTokenQueryResult = Apollo.QueryResult<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>;